import React, { Fragment } from 'react';
import late1 from '../../../../images/late1.png';
import late2 from '../../../../images/late2.png';
import late3 from '../../../../images/late3.png';

const CarNotInSpot = () => (
  <Fragment>
    <p>
      There is a <strong>$0.45/minute late charge</strong> when returning
      the vehicle late. Late fees will be displayed on the Dashboard when
      you have a current booking that you have not ended before your
      scheduled end time.
    </p>
    <br />
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={late1} style={{ height: '455px', width: '200px' }} />
    </div>
    <br />
    <p>
      Late charges update every minute, and are automatically applied to
      your account as soon as you lock the vehicle and end your booking.
    </p>
    <p>
      If there is another driver scheduled to the same vehicle after you,
      the waiting driver is credited{' '}
      <strong>$0.33/minute late credit</strong> for the time spent waiting
      for the vehicle to return. The waiting driver must select “Wait for
      vehicle” to start the timer and can stop waiting at any time. The
      waiting driver will still receive reimbursement for any time that was
      spent waiting for the vehicle to return.
    </p>
    <br />
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={late2} style={{ height: '455px', width: '200px' }} />
      <img src={late3} style={{ height: '455px', width: '200px' }} />
    </div>
  </Fragment>
);

export default CarNotInSpot;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/DrivesharingPolicies/CarNotInSpot.js